module.exports = __webpack_public_path__ + "static/media/playbtn.9589ea05.svg";